import script from "./RightMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RightMenu.vue?vue&type=script&setup=true&lang=js"

import "./RightMenu.vue?vue&type=style&index=0&id=16cabbba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16cabbba"]])

export default __exports__